import React from 'react'
import { Link } from 'react-router-dom'
import { Navigate, useNavigate } from 'react-router-dom'
import { useEffect } from "react";

const Salir = () => {
    const navigate = useNavigate();
    setTimeout(() => {
        localStorage.clear()
        navigate('/cuenta');
    }, 1);
}

export default Salir
